{
  "about": {
    "licensing": "The game is under active development: things may change or break. Photographs come from open archives and player uploads, each one is moderated and credited. If you hold the rights to an image and believe it was posted without grounds — write through the <feedback>feedback form</feedback>, and it will be taken down.",
    "scoringPlace": "<b>Place — up to 500 points.</b> The great-circle distance between your pin and the real spot is measured. Within 5 km you get the full score, beyond that it falls off.",
    "scoringQuest": "<b>A quest is the sum of its rounds.</b> Five rounds of 1000 points make 5000 for a quest.",
    "scoringTitle": "How points are counted",
    "scoringYear": "<b>Year — up to 500 points.</b> An exact hit gives the maximum, and every year off lowers the result.",
    "supportText": "The server, the storage and the domain cost money. If you enjoy the game, the author would appreciate your support.",
    "supportTitle": "Support",
    "title": "About",
    "what": "ChronoGuessr is a game about historical photography. Each round you answer two things: where the photo was taken and in what year. The more precise the answer, the more points: up to 500 for the place and up to 500 for the year."
  },
  "admin": {
    "goConfirm": "Open",
    "goQuestion": "Open the admin panel?",
    "goTitle": "Admin panel"
  },
  "announcements": {
    "empty": "No announcements yet.",
    "gotIt": "Got it",
    "more_one": "{{count}} more announcement — in your profile",
    "more_other": "{{count}} more announcements — in your profile",
    "tab": "Announcements",
    "title": "Announcement"
  },
  "auth": {
    "captchaHint": "Confirm that you are not a robot",
    "error": {
      "email": "Invalid email",
      "loginRequired": "Enter your email or username",
      "passwordMismatch": "Passwords do not match",
      "passwordRepeat": "Repeat the password",
      "passwordRequired": "Enter your password",
      "passwordShort": "At least 8 characters",
      "privacy": "Sign-up is not possible without consent",
      "usernameChars": "Latin letters, digits, hyphen and underscore only",
      "usernameLong": "At most 32 characters",
      "usernameShort": "At least 3 characters"
    },
    "field": {
      "email": "Email",
      "login": "Email or username",
      "password": "Password",
      "passwordConfirm": "Repeat the password",
      "username": "Username"
    },
    "login": {
      "forgot": "Forgot your password?",
      "noAccount": "No account yet?",
      "signUp": "Sign up",
      "submit": "Sign in",
      "submitting": "Signing in…",
      "subtitle": "Sign in to keep playing and saving your results",
      "title": "Welcome back"
    },
    "register": {
      "haveAccount": "Played before?",
      "privacyLink": "privacy policy",
      "privacyPrefix": "I consent to the processing of my personal data and accept the",
      "submit": "Sign up",
      "submitting": "Creating…",
      "subtitle": "An account keeps your score, puts you on the leaderboard and lets you play with friends",
      "title": "Create an account"
    },
    "restoring": "Restoring your session…"
  },
  "avatar": {
    "apply": "Use this area",
    "cropHint": "Drag the circle and resize it by the corner — this square becomes your avatar.",
    "cropTitle": "Choose the area"
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "forward": "Forward",
    "loading": "Loading…",
    "retry": "Try again",
    "save": "Save"
  },
  "confirmEmail": {
    "checking": "Confirming the address…",
    "doneHint": "Sign-in, password recovery and all notifications now go to the new address.",
    "doneSubtitle": "Your account now uses {{email}}",
    "doneTitle": "Address changed",
    "errorHint": "The link works once and expires after a while. Request a new one from your profile.",
    "errorTitle": "The link did not work",
    "failed": "Could not confirm the address. Please try again later.",
    "noToken": "The link has no confirmation token. Open the email again.",
    "title": "New address",
    "toProfile": "Go to profile"
  },
  "cookies": {
    "label": "Cookie notice",
    "text": "We use only essential cookies: they keep you signed in. On the sign-in and sign-up pages, Google reCAPTCHA sets its own cookies to protect against bots. No advertising or analytics cookies.",
    "more": "Learn more",
    "ok": "Got it"
  },
  "create": {
    "addPhoto": "Add a photo",
    "areaClear": "Clear area",
    "areaHint": "Click the map to outline the area where the photo was taken. Use it when the exact spot cannot be named.",
    "areaNeedMore_one": "{{count}} more point is needed to close the shape.",
    "areaNeedMore_other": "{{count}} more points are needed to close the shape.",
    "areaReady_one": "Area of {{count}} point. A guess inside it counts as exact.",
    "areaReady_other": "Area of {{count}} points. A guess inside it counts as exact.",
    "areaUndo": "Undo point",
    "caption": "What is in the photo",
    "captionPlaceholder": "A courtyard on Vasilyevsky Island",
    "clickMap": "Click the map to set the real place the photo was taken.",
    "consent": "I am submitting the quest for moderation, confirm that I have not uploaded inappropriate content, and agree that the quest may be edited or deleted.",
    "cover": "Quest cover",
    "coverEmpty": "no cover",
    "coverHint": "Shown on the quest card. Without it the first round's photo is used — and then one round is visible before the game.",
    "description": "Description",
    "descriptionPlaceholder": "What makes this set interesting",
    "editLead": "Fix the frames, the answers and the description. After sending, the quest goes back to moderation.",
    "editPublishedNote": "The quest is already published. Your edit goes to moderation as a new version, and the current one stays playable until the new one is approved.",
    "editSubmit": "Send the edit",
    "editTitle": "Edit the quest",
    "failed": "Could not create the quest",
    "lead": "Put together a set of photos: give each one a place and a year. After submitting, the quest goes to moderation.",
    "minRoundsHint": "Add {{count}} more — a quest needs at least {{min}} photos: players choose how many rounds to play.",
    "mode": {
      "area": "Area",
      "point": "Point"
    },
    "name": "Title",
    "namePlaceholder": "Streets of my city",
    "noPhotos": "No photos yet. Add images — JPEG, PNG or WebP. A quest needs at least {{min}}.",
    "point": "Point: {{lat}}, {{lng}} · {{year}}",
    "readyHint": "Every round needs an uploaded photo and a place on the map. Ready: {{ready}} of {{total}}.",
    "rejectedNote": "The moderator rejected the previous version: {{comment}}",
    "removeRound": "Remove the round",
    "rounds": "Rounds ({{count}})",
    "sourceHint": "A link, a book with a page, a museum, licence terms — anything that leads to the original. Players see it only after they answer.",
    "sourceLabel": "Source",
    "sourcePlaceholder": "Library of Congress, Prokudin-Gorsky collection, 1911\nor https://www.loc.gov/pictures/item/...",
    "submit": "Submit for moderation",
    "submitting": "Sending…",
    "tags": "Tags",
    "tagsHint": "Pick from the list — tags are shown in the reader's language.",
    "tagsPlaceholder": "city, architecture, 1950s",
    "title": "New quest",
    "uploadFailed": "Could not upload the image",
    "uploading": "uploading…",
    "whereTaken": "Where the photo was taken",
    "yearRange": "Exact year unknown — set a period",
    "yearRangeHint": "Any year inside the period counts as an exact answer. Players are told about it in advance.",
    "yearTo": "End of the period"
  },
  "deletion": {
    "title": "Delete account",
    "when": "Your account will be deleted from the server in 24 hours.",
    "whatGoes": "Your answers, scores, game history, rooms and support messages will be deleted with it.",
    "whatStays": "Quests and photos you created and didn't delete yourself will stay public — without your name.",
    "cancel": "Changed your mind? Sign in within 24 hours and cancel the deletion.",
    "email": "After deletion you can sign up again with this email address.",
    "agree": "I understand that my account will be deleted in 24 hours and my quests will stay public, and I want to delete my account",
    "password": "Account password",
    "confirm": "Delete account",
    "deleting": "Deleting…",
    "button": "Delete account",
    "doneTitle": "Your account will be deleted",
    "doneText": "Deletion is scheduled for {{date}}. You have been signed out on all devices.",
    "doneCancelHint": "If you change your mind, sign in before then and cancel the deletion.",
    "doneButton": "Got it",
    "pendingTitle": "Account is being deleted",
    "pendingText": "This account will be deleted on {{date}} — in {{hours}} h {{minutes}} min.",
    "pendingHint": "Cancel the deletion to keep using your account, or sign out — then it will be deleted as scheduled.",
    "cancelButton": "Cancel deletion",
    "logoutButton": "Sign out"
  },
  "error": {
    "httpStatus": "The request failed with status {{status}}",
    "network": "Could not reach the server. Check your connection.",
    "upload": "Could not upload the file to storage"
  },
  "favorites": {
    "add": "Add to favorites",
    "empty": "Nothing here yet. Tap the heart on a quest to save it for later.",
    "remove": "Remove from favorites",
    "title": "Favorites"
  },
  "feedback": {
    "answer": "Reply from the team",
    "empty": "You have not written to us yet.",
    "failed": "Could not send the message",
    "kind": {
      "FEEDBACK_KIND_BUG": "Bug",
      "FEEDBACK_KIND_IDEA": "Suggestion",
      "FEEDBACK_KIND_OTHER": "Other",
      "FEEDBACK_KIND_PHOTO": "Photo problem",
      "FEEDBACK_KIND_QUEST": "Quest problem"
    },
    "kindLabel": "What is this about",
    "messageLabel": "Describe the problem",
    "messagePlaceholder": "What happened and on which screen. The more detail, the faster we fix it.",
    "open": "Report a problem",
    "photoProblem": "Problem with the photo?",
    "questProblem": "Problem with the quest?",
    "send": "Send",
    "sending": "Sending…",
    "sentText": "Thank you. The reply will appear in your profile, under “Messages”.",
    "sentTitle": "Message sent",
    "status": {
      "FEEDBACK_STATUS_NEW": "Awaiting reply",
      "FEEDBACK_STATUS_ANSWERED": "Answered",
      "FEEDBACK_STATUS_CLOSED": "Closed"
    },
    "tab": "Messages",
    "title": "Report a problem",
    "topic": {
      "place": "Place on the map",
      "year": "Year",
      "quality": "Image quality",
      "source": "Source",
      "other": "Other"
    },
    "topicLabel": "What is wrong"
  },
  "footer": {
    "about": "About and support",
    "privacy": "Privacy policy",
    "tagline": "ChronoGuessr — guess the place and year of a historical photo"
  },
  "forgot": {
    "backToLogin": "Back to sign in",
    "otherAddress": "Use a different address",
    "remembered": "Remembered your password?",
    "sending": "Sending…",
    "sent": {
      "hint": "The link works once and expires after a while. Emails sometimes land in Spam — check there too.",
      "retry_one": "You can request another email in {{count}} second.",
      "retry_other": "You can request another email in {{count}} seconds.",
      "subtitle": "If an account with {{email}} exists, the reset link has been sent",
      "title": "Check your email"
    },
    "submit": "Send the link",
    "subtitle": "Enter the address your account is registered to — we will send a reset link",
    "title": "Password recovery"
  },
  "format": {
    "bc": "{{year}} BC",
    "exactYear": "spot on",
    "km": "{{value}} km",
    "meters": "{{value}} m",
    "years_one": "{{count}} year",
    "years_other": "{{count}} years"
  },
  "guide": {
    "create": {
      "title": "Your own quests",
      "text": "The “Create” button builds a quest from your images: a place, a year and a source for each frame. At least five — fewer leaves the player nothing to choose from. After sending, the quest goes through moderation. A published one can be edited — the edit goes as a new version, and the current one stays playable."
    },
    "feedback": {
      "title": "If something is wrong",
      "text": "“Feedback” in the menu under your avatar reports a problem or suggests an idea. After answering, a frame has “Problem with the photo?”, and a quest has “Problem with the quest?”. The reply arrives in your profile, under “Messages”."
    },
    "game": {
      "title": "The game",
      "text": "You are shown a historical image — a photograph, a painting or an engraving. Guess two things: where it was taken and in which year. The closer you are, the more points: up to 500 for the place and up to 500 for the year."
    },
    "lead": "A short tour of what is here and how to use it. To open it again, pick “Guide” in the menu under your avatar.",
    "open": "How to play",
    "quests": {
      "title": "Quests",
      "text": "A quest is a collection of photos — it may hold hundreds. You choose how many rounds to play before you start, up to ten; the photos are drawn at random, so a second run is not the first one again. The catalogue sorts by date, views and rating. Tap the heart to save a quest for later, and rate it with stars once you have played it. The daily quest is the exception: it is the same for everyone, or the shared leaderboard would compare different games."
    },
    "room": {
      "title": "Playing with friends",
      "text": "“Create a room” in the header. Send friends the code or the link — or invite them straight from a player's profile. The room outlives a game, there is no need to regroup every time; the host sets the length, and it is the same for everyone."
    },
    "round": {
      "title": "A round",
      "text": "Drop a pin on the map, pick a year and press “Answer”. Sometimes an exact spot or year does not exist: then you need to hit an area on the map or a period. Such rounds are announced in advance — on the quest page and in the round itself."
    },
    "start": "Got it, let’s start",
    "title": "Welcome to ChronoGuessr"
  },
  "invite": {
    "accept": "Join",
    "button": "Invite to a room",
    "failed": "Could not respond to the invitation",
    "sent": "Invitation sent",
    "text": "“{{username}}” invites you to join a game",
    "title": "Game invitation"
  },
  "join": {
    "connecting": "Connecting to the room…",
    "failed": "Could not connect",
    "joining": "Connecting…",
    "lead": "Enter the room code your friend sent you.",
    "submit": "Enter the room",
    "title": "Join a game"
  },
  "landing": {
    "kicker": "historical photographs from around the world",
    "lead": "One photograph. One pin on the map. One year.",
    "play": "Play",
    "title": "Guess <accent>where and when</accent> the photo was taken"
  },
  "language": {
    "label": "Language",
    "switch": "Change language"
  },
  "leaderboard": {
    "date": "Date",
    "emptyText": "Either nobody has played the daily quest yet, or there was none that day.",
    "emptyTitle": "No results for this date",
    "lead": "Results for the daily quest",
    "title": "Leaderboard",
    "today": "today",
    "yourResult": "{{name}} — your result"
  },
  "lobby": {
    "copied": "Copied",
    "copy": "Copy",
    "hint": "The room owner starts the game. Once they press Start, the first round opens for everyone at the same moment.",
    "host": "host",
    "inviteCode": "Invite code",
    "leave": "Leave the room",
    "leaveFailed": "Could not leave the room",
    "leaving": "Leaving…",
    "notFound": "Room not found",
    "opening": "Opening the room…",
    "perRound": "{{minutes}} min per round",
    "players_one": "Players ({{count}})",
    "players_other": "Players ({{count}})",
    "start": "Start the game",
    "startFailed": "Could not start the game",
    "starting": "Starting…",
    "title": "Waiting room",
    "waiting": "waiting for players"
  },
  "map": {
    "realPlace": "Real place",
    "yourGuess": "Your guess"
  },
  "nav": {
    "about": "About",
    "create": "Create",
    "feedback": "Feedback",
    "guide": "Guide",
    "leaderboard": "Leaderboard",
    "login": "Sign in",
    "logout": "Sign out",
    "menu": "Menu",
    "profile": "Profile",
    "quests": "Quests",
    "register": "Sign up"
  },
  "notFound": {
    "home": "Go home",
    "text": "There is no such address. The quest may have been deleted, or the link has a typo.",
    "title": "This page is lost in time"
  },
  "onboarding": {
    "hint": "A round is worth up to 1000 points. Look closely at the details: signs, vehicles, clothing. The photo can be zoomed in.",
    "notAlways": {
      "area": "Some rounds ask for an area instead of a spot: an old photograph often does not pin the place closer than a city block.",
      "period": "Some rounds ask for a period instead of a year: for a painting or an engraving, even the archive does not know the exact date.",
      "title": "It is not always a point and a year",
      "where": "Both are announced on the quest page and in the round itself, so you never hunt for precision that does not exist."
    },
    "place": {
      "text": "Click the map to drop a pin. The closer to the real spot, the more points — up to 500.",
      "title": "Find the place on the map"
    },
    "start": "Got it, let's start",
    "submit": {
      "text": "The button becomes active once both the place and the year are set. After answering you see the breakdown: where the photo was really taken and how the points were earned.",
      "title": "Send your answer"
    },
    "subtitle": "Every round is one historical photograph. You give two answers.",
    "title": "How to play",
    "year": {
      "text": "The slider picks the era roughly, the field next to it sets the exact year. A perfect hit is 500 points, and the score falls off from there.",
      "title": "Name the year"
    }
  },
  "password": {
    "aria": "Password strength: {{label}}",
    "fair": "fair",
    "good": "good",
    "hintDictionary": "Replace dictionary words and sequences like qwerty or 12345.",
    "hintLonger": "The simplest way to strengthen it is to make it longer: three or four unrelated words.",
    "hintPersonal": "The password contains your name or email — pick words unrelated to them.",
    "strong": "strong",
    "tooShort": "At least 8 characters are needed.",
    "veryWeak": "very weak",
    "weak": "weak"
  },
  "photo": {
    "resetZoom": "Reset zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out"
  },
  "play": {
    "accepted": "Answer accepted",
    "areaHint": "Place: hit the area",
    "getReady": "Get ready",
    "leave": "Leave the game",
    "loadFailed": "Could not load the game",
    "loading": "Loading the game…",
    "photoCollapse": "Hide",
    "photoExpand": "Show",
    "pinHint": "Drop a pin on the map to send your answer.",
    "pinHintArea": "Drop a pin inside the right area to submit your answer.",
    "players_one": "{{count}} player",
    "players_other": "{{count}} players",
    "roundMissing": "Round not found — the game may already be over",
    "roundOf": "Round {{current}} of {{total}}",
    "submit": "Answer",
    "submitFailed": "Could not send the answer",
    "submitting": "Sending…",
    "toResults": "To the quest results",
    "waiting": "Waiting for the others: {{answered}} of {{total}} have answered. The round closes automatically when the timer runs out.",
    "yearRangeHint": "Year: hit the period"
  },
  "privacy": {
    "disclaimer": "This document is written as a standard one and describes how the service actually works. Before a public launch it should be reviewed by a lawyer and completed with the controller's full details.",
    "sections": [
      {
        "text": [
          "The data controller is the owner of the ChronoGuessr service available at chronoguessr.io. The controller can be reached at privacy@chronoguessr.io."
        ],
        "title": "1. Who processes the data"
      },
      {
        "items": [
          "the email address and username given at sign-up;",
          "the password — only as an irreversible cryptographic hash; the original password is never stored;",
          "IP address and request times — to protect against password guessing and automated sign-ups;",
          "game data: quests played, answers, points scored, game history;",
          "content you upload yourself: photographs, their descriptions, coordinates and source links."
        ],
        "note": "The service does not collect special categories of personal data or biometric data.",
        "title": "2. What data is collected"
      },
      {
        "items": [
          "creating an account, signing in and confirming the email address;",
          "running the game itself: sessions, scoring, leaderboards and the player profile;",
          "moderating user-uploaded content;",
          "protecting the service from automated sign-ups and password guessing;",
          "replying to messages sent to the controller."
        ],
        "note": "The data is not used for advertising or passed to third parties for marketing purposes.",
        "title": "3. Why it is needed"
      },
      {
        "text": [
          "Processing is based on your consent, which you give at sign-up by ticking the corresponding box. The consent is specific, informed and deliberate, as required by Russian Federal Law No. 152-FZ of 27 July 2006 “On Personal Data”."
        ],
        "title": "4. On what legal basis"
      },
      {
        "items": [
          "the hosting provider — running the server and storing the database;",
          "the email delivery service — sending the address confirmation email; only the recipient address and the message text are passed to it;",
          "Google reCAPTCHA — checking that a form is filled in by a human; data about your browser is passed to the service under Google's policy;",
          "Yandex Maps — the map base layer; when map tiles are loaded, data about your browser is passed to the service under Yandex's policy."
        ],
        "note": "Otherwise data is disclosed to third parties only where required by law.",
        "text": [
          "The controller uses contractors to keep the service running. Each of them receives only the minimum needed for its task:"
        ],
        "title": "5. Who the data may be shared with"
      },
      {
        "text": [
          "Account data is kept as long as the account exists. After an account is deleted, personal data is erased and game results are anonymised or deleted with it. Records of request times and IP addresses are kept for no more than one year and are used only to protect the service."
        ],
        "title": "6. How long the data is kept"
      },
      {
        "items": [
          "to obtain information about the data being processed;",
          "to require that data be corrected, blocked or deleted if it is incomplete, outdated or obtained unlawfully;",
          "to withdraw consent at any moment;",
          "to appeal the controller's actions to the competent data protection authority."
        ],
        "note": "To withdraw consent or request deletion, write to privacy@chronoguessr.io. Withdrawing consent means deleting the account: without processing the email address, signing in is not possible.",
        "title": "7. Your rights"
      },
      {
        "text": [
          "The connection to the service is encrypted with HTTPS. Passwords are stored only as an argon2id hash, from which the original password cannot be recovered. Access to the database is limited to the server's internal network. Uploaded files are served through temporary links with a limited lifetime."
        ],
        "title": "8. How the data is protected"
      },
      {
        "text": [
          "The service uses a single essential cookie: it stores the session identifier so you don't have to enter your password on every visit. It is not accessible from JavaScript and is not used for tracking or advertising.",
          "The sign-in and sign-up pages use Google reCAPTCHA. It sets its own cookies to tell humans from bots; their processing is governed by Google's privacy policy.",
          "Interface settings — language, theme, sound, and the note that the cookie notice has been read — are kept in your browser's storage (localStorage) and are never sent to the server.",
          "Visits are counted without cookies or identifiers: a visit is recorded as a hash of the IP address and browser type with a salt that changes daily and is then deleted. Such a hash cannot be turned back into an address, and one person's visits on different days cannot be linked.",
          "The service sets no analytics or advertising cookies. You can block cookies in your browser settings, but then your sign-in will not persist between visits."
        ],
        "title": "9. Cookies",
        "id": "cookies"
      },
      {
        "text": [
          "The controller may change this policy. Every revision has a number, and the revision in force at the moment of sign-up is stored together with your consent. If the changes are material, consent is requested again."
        ],
        "title": "10. Changes to this policy"
      }
    ],
    "subtitle": "Consent to the processing of personal data",
    "title": "Privacy policy",
    "version": "revision of {{version}}"
  },
  "profile": {
    "avatarRemoved": "Profile picture deleted.",
    "average": "Average score",
    "averageError": "average error",
    "averageMiss": "average miss",
    "best": "Best result",
    "changeEmail": "Send the confirmation",
    "changePassword": "Change password",
    "createQuest": "Create your own quest",
    "currentPassword": "Current password",
    "edit": "Edit profile",
    "editQuest": "Edit",
    "emailButton": "Change email",
    "emailHint": "The address changes only after you open the link sent to the new one. Your password confirms it is really you.",
    "emailSent": "A link has been sent to {{email}}. The address changes once you open it.",
    "emailTitle": "Email address",
    "gamesTogether_one": "{{count}} game together",
    "gamesTogether_other": "{{count}} games together",
    "history": "Game history",
    "moderator": "Moderator: {{comment}}",
    "myQuests": "My quests",
    "newEmail": "New address",
    "newPassword": "New password",
    "noGames": "No finished games yet.",
    "noQuests": "You have not created a quest yet.",
    "noRecentPlayers": "Nobody yet — invite friends to a room, and they will show up here.",
    "notFound": "Profile not found",
    "passwordChanged": "Password changed. Other devices will need to sign in again.",
    "passwordTitle": "Password",
    "perQuest": "points per quest",
    "perRound": "points per round",
    "pickAvatar": "Add a photo",
    "pickQuest": "Pick a quest",
    "placeAccuracy": "Place accuracy",
    "questsHint_one": "quest",
    "questsHint_other": "quests",
    "questsPlayed": "Quests finished",
    "recentPlayers": "Recently played with",
    "removeAvatar": "Delete",
    "removeAvatarConfirm": "Are you sure you want to delete your profile picture?",
    "removeAvatarNo": "No",
    "removeAvatarTitle": "Delete profile picture",
    "removeAvatarYes": "Yes, delete",
    "roundsHint_one": "round",
    "roundsHint_other": "rounds",
    "roundsPlayed": "Rounds played",
    "saved": "Saved",
    "saving": "Saving…",
    "tab": {
      "announcements": "Announcements",
      "favorites": "Favorites",
      "history": "Game history",
      "messages": "Messages",
      "overview": "Overview",
      "quests": "My quests"
    },
    "title": "Player profile",
    "uploading": "Uploading…",
    "yearAccuracy": "Year accuracy"
  },
  "quest": {
    "by": "by",
    "byAuthor": "by {{author}}",
    "daily": "daily quest",
    "noCover": "no cover",
    "notRated": "not rated",
    "photos_one": "{{count}} photo",
    "photos_other": "{{count}} photos",
    "rounds_one": "{{count}} round",
    "rounds_other": "{{count}} rounds",
    "status": {
      "archived": "archived",
      "draft": "in review",
      "published": "published",
      "rejected": "rejected"
    },
    "views_one": "{{count}} view",
    "views_other": "{{count}} views",
    "world": "every photo"
  },
  "questPage": {
    "author": "author: {{name}}",
    "createFailed": "Could not create the game",
    "createRoom": "Create a room",
    "hasAreas": "Some rounds ask for an area on the map rather than an exact spot.",
    "hasYearRanges": "Some rounds ask for a period rather than an exact year.",
    "inviteHint": "Gather a room with the button in the header and play together with friends",
    "leaderboard": "Top players",
    "leaderboardLogin": "The quest leaderboard is visible to signed-in players only.",
    "minutes_one": "{{count}} minute",
    "minutes_other": "{{count}} minutes",
    "moderatorNote": "Moderator's note",
    "noResults": "Nobody has finished this quest yet. Take the first place.",
    "noTimer": "No time limit",
    "notFound": "Quest not found",
    "rateAfterPlaying": "You can rate a quest after playing it.",
    "ratingSummary": "{{rating}} — {{count}} ratings",
    "roomHint_one": "The game starts for everyone online: {{count}} member in the room.",
    "roomHint_other": "The game starts for everyone online: {{count}} members in the room.",
    "roundsLabel": "Rounds in this game",
    "solo": "Play",
    "startTitle": "Start a game",
    "timerLabel": "Time per round",
    "whatToExpect": "What to expect"
  },
  "quests": {
    "dailyLead": "The same set of photos for every player — compare your result on the shared leaderboard.",
    "emptyText": "Try changing the query or clearing the tag filter.",
    "emptyTitle": "Nothing found",
    "found_one": "{{count}} quest found",
    "found_other": "{{count}} quests found",
    "loadFailed": "Could not load the quests",
    "resetFilters": "Clear filters",
    "searchPlaceholder": "Search by title or description…",
    "sortCreated": "By date",
    "sortLabel": "Sort",
    "sortRating": "By rating",
    "sortViews": "By views",
    "subtitle": "Collections of historical photographs",
    "tagSearch": "Find a tag",
    "tagsHidden": "and {{count}} more",
    "tagsNotFound": "nothing found",
    "title": "Quest catalogue"
  },
  "reset": {
    "broken": {
      "hint": "Email clients sometimes break long links — try copying it from the email in full.",
      "subtitle": "The link has no reset token. Open the email again.",
      "title": "The link did not work"
    },
    "done": {
      "hint": "If you were signed in on other devices, you will need to sign in there too: a password is changed exactly to take that access away.",
      "subtitle": "Previous sessions are closed — sign in again with the new password",
      "title": "Password changed"
    },
    "expired": "Link expired?",
    "requestNew": "Request a new link",
    "requestNewShort": "Request a new one",
    "saving": "Saving…",
    "submit": "Change password",
    "subtitle": "Choose a password you do not use on other sites",
    "title": "New password"
  },
  "results": {
    "breakdown_one": "Breakdown of {{count}} round",
    "breakdown_other": "Breakdown of {{count}} rounds",
    "loadFailed": "Could not load the results",
    "outOf": "out of {{max}} possible",
    "playAgain": "Play again",
    "playerScores": "Player scores",
    "realYear": "actual year: {{year}}",
    "roundNumber": "Round {{number}}",
    "share": "Share the result",
    "shareText": "ChronoGuessr — “{{quest}}”: {{score}} out of {{max}} points. {{url}}",
    "source": "Photo source",
    "title": "Quest finished",
    "toCatalogue": "Back to quests",
    "topPlayer": "Top score:"
  },
  "role": {
    "admin": "admin",
    "moderator": "moderator"
  },
  "room": {
    "close": "Close the room",
    "codePlaceholder": "Invite code",
    "create": "Create a room",
    "inviteCode": "Invite code",
    "joinFailed": "Could not join the room",
    "joinOther": "Join another room",
    "joinSubmit": "Join",
    "joinWarning": "You will leave this room and join the one whose code you entered.",
    "joinWarningHost": "Your room will close and you will join the one whose code you entered.",
    "joined": "You joined the room",
    "leave": "Leave the room",
    "onlyHost": "Only the room host can start a game.",
    "pickQuestHint": "Open a quest and press “Play with the room” — the game starts for everyone online.",
    "playWithRoom": "Play with the room",
    "playing": "The room is playing right now.",
    "remove": "Remove {{name}} from the room",
    "starting": "Starting…",
    "title": "Room"
  },
  "round": {
    "fromAreaEdge": "from the edge of the area",
    "fromPeriodEdge": "from the nearest end of the period",
    "fromRealSpot": "from the real spot",
    "insideArea": "inside the area",
    "insideAreaHint": "an exact answer",
    "insideYears": "Within period",
    "insideYearsHint": "your year falls inside the dating period",
    "next": "Next round",
    "original": "original photo",
    "outOf": "out of {{max}}",
    "place": "Place",
    "realPeriod": "Dated",
    "realYear": "Actual year",
    "source": "Source",
    "whatIsIt": "What is in the photo",
    "year": "Year",
    "yearGap": "difference from the real one",
    "yourAnswer": "Your answer"
  },
  "seo": {
    "quests": "ChronoGuessr quest catalog: historical photos and paintings by city, country and era, from the 1700s to the 2020s. Guess the place and the year.",
    "quest": "A ChronoGuessr quest of {{count}} images: pin where each photo was taken on the map and name the year.",
    "leaderboard": "ChronoGuessr daily quest leaderboard: who guessed the place and year of today's historical photos most precisely.",
    "about": "How ChronoGuessr works, how points for place and year are scored, and where the historical photos come from.",
    "login": "Sign in",
    "register": "Sign up"
  },
  "share": {
    "challengeGuest": "Sign in or sign up to play this quest and compare the scores.",
    "challengeText": "Play the same quest and compare the scores.",
    "challengeTitle": "Think you can do better?",
    "hint": "Anyone with the link sees the quest and this result. The answers stay hidden.",
    "link": "Link",
    "notFound": "This result is not available",
    "play": "Play this quest",
    "playedQuest": "Played the quest",
    "qrAlt": "QR code with the link to the result",
    "qrHint": "Point a phone camera at the code to open the result there.",
    "title": "Share the result"
  },
  "sound": {
    "label": "Sound",
    "off": "Off",
    "on": "On"
  },
  "theme": {
    "dark": "Dark",
    "label": "Theme",
    "light": "Light",
    "toDark": "Dark theme",
    "toLight": "Light theme"
  },
  "verify": {
    "banner": "Confirm the address <mail>{{email}}</mail> to play and create quests.",
    "failed": "Could not send the email. Please try again later.",
    "resend": "Send the email again",
    "sending": "Sending…",
    "sent": "Email sent to {{email}}. Check your inbox."
  },
  "verifyPage": {
    "already": "Address already confirmed",
    "alreadyHint": "The link works once, but there is nothing left to confirm.",
    "brokenHint": "The link works once and expires after a while. Sign in and request a new email.",
    "brokenTitle": "The link did not work",
    "checking": "Confirming the address…",
    "done": "Address confirmed",
    "doneHint": "All game modes are now open: solo, rooms with friends and your own quests.",
    "failed": "Could not confirm the address. Please try again later.",
    "noToken": "The link has no confirmation token. Open the email again."
  },
  "year": {
    "label": "Year taken",
    "manual": "Enter the year manually"
  }
}
